/**
 * The ONE buyer-facing label for an agent whose license verification is
 * submitted but not yet approved (supply `DeliveryState` = `pending_labeled`).
 * Shown on the offer card, agent detail and the accept sheet (SEC-07: a
 * pending agent can connect at the full fee; the free first connection waits
 * for verification).
 */
export const PRO_VERIFICATION_PENDING_LABEL = "License verification in progress";

/** Accept-sheet sentence shown under the label. */
export const PRO_VERIFICATION_PENDING_SHEET_NOTE =
  "Sill hasn't finished checking this agent's real estate license yet. You can still connect.";
